/// <amd-module name="Wit/WorkItemModel/RuleEngine/WorkItemStore" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IVssPageService } from "VSS/Platform/Page";
import { WorkItemIdentityRef } from "Wit/Identity/Interfaces/WorkItemInterfaces";
import { getDistinctDisplayName } from "Wit/Identity/Utilities/WorkItemIdentityHelper";

export class WorkItemStore {
    private _pageContext: IVssPageContext;
    public constantSets: { [key: string]: string[] };

    public constructor(pageContext: IVssPageContext, constantSets: { [key: string]: string[] }) {
        this._pageContext = pageContext;
        this.constantSets = constantSets;
    }

    public getCurrentUserName(): string {
        return this.getCurrentUser().distinctDisplayName;
    }

    public getCurrentUser(): WorkItemIdentityRef {
        const pageData = this._pageContext.getService<IVssPageService>("IVssPageService").getData()!;
        const identity = pageData.user;
        const displayName = identity.displayName;
        const uniqueName = identity.uniqueName;

        return {
            distinctDisplayName: getDistinctDisplayName(displayName, uniqueName),
            identityRef: {
                id: identity.id,
                displayName: displayName,
                uniqueName: uniqueName
            } as IdentityRef
        };
    }

    public getConstantSet(setId: string): string[] {
        if (setId in this.constantSets) {
            return this.constantSets[setId];
        } else {
            console.error("Could not find set ID:" + setId);
            return [];
        }
    }
}
